import { oc } from "@orpc/contract";
import { z } from "zod";
import { sendFromOverrideSchema } from "./ar-statement-email.contract";

export const arStatementDefaultsOutputSchema = z.object({
  defaultRecipientEmails: z.array(z.string()),
  bccSender: z.boolean().optional(),
  customEmail: z.string().optional(),
  sendFrom: sendFromOverrideSchema.optional(),
});

export type ArStatementDefaultsOutput = z.infer<
  typeof arStatementDefaultsOutputSchema
>;

export const arStatementDefaultsContracts = {
  get: oc
    .input(z.object({ customerId: z.string().uuid() }))
    .output(arStatementDefaultsOutputSchema)
    .route({
      method: "GET",
      summary: "Get default statement recipients for a customer",
    }),
} as const;
